module.exports = __webpack_public_path__ + "images/scroll_logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/scroll_logo.png
// module id = 13
// module chunks = 0